import { type User } from '@auth0/auth0-react';
import { isUsingDarkTheme } from '@strata/react-header';

import { type FmhToken } from 'api/authAPI';

export const initializePendo = (fmhToken: FmhToken, user: User | undefined) => {
    if (user) {
        pendo.initialize({
            apiKey: process.env.REACT_APP_PENDO_API_KEY,
            visitor: {
                id: user.email!,
                email: user.email!,
                name: user.name!,
                dark_mode: isUsingDarkTheme(),
                role: fmhToken.role_name,
            },
            account: { id: user.email!.split('@')[1], org: 'Free Market Health' },
        });
    }
};
